export default __webpack_public_path__ + "static/media/emptyIcon.a1e1370b.svg";